import axios from 'axios';

const CONTACTOS_URL = '/contacto';
const CALLCENTER_URL = '/call-center'
class ContactosService {
    static getContactos(form = {
        perPage: 15,
        page: 1,
        sortBy: 'created_at',
        sortDesc: true,
        filter: null,
        fuente: '' }) {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.get(`${CONTACTOS_URL}`, {
                    params: {
                        ...form
                    },
                });
                const contactos = res.data;

                resolve(contactos);
            } catch (error) {
                console.error(error);
                reject(error.response.data);
            }
        })
    }

    static getRazones() {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.get(`${CONTACTOS_URL}/razones`);

                resolve(res.data);
            } catch (error) {
                console.error(error);
                reject(error.response.data);
            }
        });
    }

    static getFuentes() {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.get(`${CONTACTOS_URL}/fuentes`);

                resolve(res.data);
            } catch (error) {
                console.error(error);
                reject(error.response.data);
            }
        });
    }

    static setRazon(idContacto, razon) {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.post(`${CONTACTOS_URL}/${idContacto}/razon`, {
                    razon: razon
                });

                resolve(res.data);
            } catch (error) {
                console.error(error);
                reject(error.response.data);
            }
        });
    }

    static getTelefonos() {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.get(`${CONTACTOS_URL}/telefonos`);

                resolve(res.data);
            } catch (error) {
                console.error(error);
                reject(error.response.data);
            }
        });
    }

    static getCorreos() {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.get(`${CONTACTOS_URL}/correos-clientes`);

                resolve(res.data);
            } catch (error) {
                console.error(error);
                reject(error.response.data);
            }
        });
    }

    static addContacto(form) {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.post(`${CALLCENTER_URL}`, form);

                resolve(res.data);
            } catch (error) {
                console.error(error);
                reject(error.response.data);
            }
        });
    }

    static addAyuda(form) {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.post(`api${CONTACTOS_URL}/ayuda`, form);

                resolve(res.data);
            } catch (error) {
                console.error(error);
                reject(error.response.data);
            }
        });
    }

    static exportarExcel() {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.post(`${CONTACTOS_URL}/exportar`);

                resolve(res.data);
            } catch (error) {
                reject(error.response.data);
            }
        });
    }
};

export default ContactosService;
